const commmonCategories = [
  { key: 'stattype', label: 'Stat type' },
  { key: 'system', label: 'System' },
  { key: 'leadtime', label: 'Leadtime' },
  { key: 'area', label: 'Area' },
  { key: 'source', label: 'Source' },
  { key: 'stat', label: 'Stat' },
];

export const getCategories = view => {
  if (view === 'depth-time') {
    return commmonCategories;
  }
  if (view === 'vertical-profile') {
    return [{ key: 'dates', label: 'Date' }, ...commmonCategories];
  }
  return [...commmonCategories, { key: 'level', label: 'Level' }];
};

export default {
  getCategories,
};
